import React from 'react';
import cn from 'classnames';
import Graphic from '../Graphic';
import sharedStyles from '../WelcomeGuide.module.scss';
import styles from './GetStarted.module.scss';
import { supportHref } from '@support/preferred-email-client';
import { useDispatch } from 'react-redux';
import { openModal } from '@actions/ui';

export default function GetStarted({ onClick, dismiss }) {
  const dispatch = useDispatch();
  const supportEmail = supportHref();

  return (
    <div className={sharedStyles.page} onClick={onClick}>
      <div className={styles.graphicContainer}>
        <Graphic className={styles.graphic} variant="colorized" />
      </div>
      <div className={cn(sharedStyles.pageContent, sharedStyles.right)}>
        <h2>Get Started</h2>
        <p>We can’t wait to see what you do with Clay.</p>
        <p>
          If you have feedback or just want to say hello, use the{' '}
          <div className={styles.link} onClick={() => dispatch(openModal('support'))}>
            Support
          </div>{' '}
          option in the top right menu, or email us directly at{' '}
          <a className={styles.link} href={supportEmail}>
            care@clay.earth
          </a>
          .
        </p>
        <p>
          We’ve just covered a few of the core features that make up Clay. If you’d like to dive
          deeper we have prepared additional resources for you in{' '}
          <a className={styles.link} href="https://library.clay.earth" target="_blank">
            our library
          </a>
          .
        </p>
        <button className={styles.btn} onClick={dismiss}>
          Get Started
          <svg viewBox="0 0 13.5 12">
            <path
              strokeWidth="2"
              strokeLinejoin="round"
              strokeLinecap="round"
              fill="none"
              d="M12.3 6.03L7.8 10.5l4.5-4.5-4.5-4.5zM10.1 6l-9 0"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
